import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarSimpleLeftWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-simple-left-wide" maskId="round-filled-radius-0-stroke-1.5-IconSidebarSimpleLeftWide"><path fillRule="evenodd" clipRule="evenodd" d="M2 4.75C2 4.33579 2.33579 4 2.75 4H21.25C21.6642 4 22 4.33579 22 4.75V19.25C22 19.6642 21.6642 20 21.25 20H2.75C2.33579 20 2 19.6642 2 19.25V4.75ZM9 5.5V18.5H20.5V5.5H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarSimpleLeftWide;
